/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SuperGroupResponse,
    SuperGroupResponseFromJSON,
    SuperGroupResponseFromJSONTyped,
    SuperGroupResponseToJSON,
} from './SuperGroupResponse';

/**
 * 
 * @export
 * @interface SuperGroupsResponse
 */
export interface SuperGroupsResponse {
    /**
     * 
     * @type {Array<SuperGroupResponse>}
     * @memberof SuperGroupsResponse
     */
    elements: Array<SuperGroupResponse>;
}

export function SuperGroupsResponseFromJSON(json: any): SuperGroupsResponse {
    return SuperGroupsResponseFromJSONTyped(json, false);
}

export function SuperGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuperGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(SuperGroupResponseFromJSON)),
    };
}

export function SuperGroupsResponseToJSON(value?: SuperGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(SuperGroupResponseToJSON)),
    };
}

